import Constant from '@/common/constant/Constant';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import {
    IconButton,
    Popover,
    Radio,
    FormControl,
    FormControlLabel,
    RadioGroup
} from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { useState } from 'react';
import {
    saveSearchCondition,
    isViewWasChanged,
    onClickOpenMoveView,
    onHandlerDeleteViewHelpdeskList,
    onHandlerHideViewHelpdeskList,
    onEditViewRange,
    getVisibleRangeByVisibleType
} from '../../handler/HelpDeskViewHandler';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PropTypes from 'prop-types';

export const SettingView = props => {
    const {
        API,
        view,
        setIsLoadingView,
        listView,
        setListView,
        viewSelected,
        setViewSelected,
        viewStructure,
        setViewStructure,
        isProjectManager,
        setIsOpenDialogViewChanged,
        userDetail,
        projectInuseDetail,
        setViewNameErrorType,
        setIsOpenDialogViewNameError
    } = props;
    const [isConfirmDeleteView, setIsConfirmDeleteView] = useState(false);
    const [isConfirmHideView, setIsConfirmHideView] = useState(false);
    const [openSettingMenu, setOpenSettingMenu] = useState(null);
    const [openSettingRange, setOpenSettingRange] = useState(null);
    const [isConfirmChangeRange, setIsConfirmChangeRange] = useState(null);
    const [currentRange, setCurrentRange] = useState(view?.visibleType || null);

    const onCloseChangeRange = async () => {
        setOpenSettingRange(null);
        if (currentRange !== view?.visibleType) {
            setOpenSettingMenu(null);
            let isViewChanged = await isViewWasChanged(view, props);
            if (isViewChanged) {
                setIsOpenDialogViewChanged(true);
            } else {
                setIsConfirmChangeRange(currentRange);
            }
        }
    };

    const onClickOkChangeRange = async () => {
        const visibleType = isConfirmChangeRange;
        await onEditViewRange({
            listView,
            view,
            visibleType,
            visibleRange: getVisibleRangeByVisibleType(
                isConfirmChangeRange,
                userDetail.id,
                projectInuseDetail.id
            ),
            setIsLoadingView,
            setListView,
            userId: userDetail.id,
            setIsConfirmChangeRange,
            setCurrentRange,
            projectInuseDetail,
            setViewNameErrorType,
            setIsOpenDialogViewNameError
        });
    };

    const onClickViewSetting = event => {
        setOpenSettingMenu(event.currentTarget);
    };

    const handleClose = () => {
        setOpenSettingMenu(null);
    };

    const onClickDeleteView = async () => {
        setIsLoadingView(true);
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        setIsLoadingView(false);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmDeleteView(true);
        }
    };

    const onClickHideView = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmHideView(true);
        }
    };

    const onClickSaveSearchCondition = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            await saveSearchCondition(
                API,
                view,
                setIsLoadingView,
                viewStructure,
                listView,
                setListView,
                viewSelected,
                setViewSelected
            );
        }
    };

    const onClickMoveView = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            onClickOpenMoveView(view, props);
        }
    };

    const onClickCloseConfirmDeleteView = () => {
        setIsConfirmDeleteView(false);
    };

    const onClickOkConfirmDeleteView = () => {
        onHandlerDeleteViewHelpdeskList(
            API,
            view,
            setIsConfirmDeleteView,
            setIsLoadingView,
            listView,
            setListView,
            viewSelected,
            setViewSelected,
            viewStructure,
            setViewStructure
        );
    };

    const onClickCloseConfirmHideView = () => {
        setIsConfirmHideView(false);
    };

    const onClickOkConfirmHideView = () => {
        onHandlerHideViewHelpdeskList(
            API,
            view,
            setIsConfirmHideView,
            setIsLoadingView,
            listView,
            setListView,
            viewSelected,
            setViewSelected,
            viewStructure,
            setViewStructure
        );
    };

    return (
        <>
            <IconButton
                className="btn-showMore"
                onClick={onClickViewSetting}
                style={{ verticalAlign: 'middle', padding: '4px 10px' }}
            >
                <img src="/assets/image/icon-nav-tabs.svg" alt="" />
            </IconButton>
            <Popover
                className="navTabs-dropMenu"
                id={Boolean(openSettingMenu) ? 'simple-popover' : undefined}
                open={Boolean(openSettingMenu)}
                anchorEl={openSettingMenu}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                onDoubleClick={(e) => e.stopPropagation()}
            >
                <ul>
                    {(isProjectManager || view?.creator === userDetail.id) &&
                        view?.viewType !== Constant.VIEW_TYPE.DEFAULT && (
                            <li onClick={e => setOpenSettingRange(e.currentTarget)}>
                                <span className="navTabs-item">
                                    <img src="/assets/image/icon-tabs-hide.svg" alt="" />
                                </span>
                                <span className="navTabs-text">公開範囲</span>
                            </li>
                        )}
                    <li onClick={onClickHideView}>
                        <span className="navTabs-item">
                            <VisibilityOffIcon style={{ width: 16 }} />
                        </span>
                        <span className="navTabs-text">非表示</span>
                    </li>
                    {view.viewType === Constant.VIEW_TYPE.CUSTOM &&
                        (isProjectManager || view?.creator === userDetail.id) && (
                            <li onClick={onClickDeleteView}>
                                <span className="navTabs-item">
                                    <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                </span>
                                <span className="navTabs-text">削除</span>
                            </li>
                        )}
                    <li onClick={onClickMoveView}>
                        <span className="navTabs-item">
                            <img src="/assets/image/icon-tabs-move.svg" alt="" />
                        </span>
                        <span className="navTabs-text">移動</span>
                    </li>
                    {view.viewType === Constant.VIEW_TYPE.CUSTOM &&
                        (isProjectManager || view?.creator === userDetail.id) && (
                            <li onClick={onClickSaveSearchCondition}>
                                <span className="navTabs-item">
                                    <img src="/assets/image/icon-tabs-search.svg" alt="" />
                                </span>
                                <span className="navTabs-text">検索条件保存</span>
                            </li>
                        )}
                </ul>
            </Popover>

            <Popover
                className="navTabs-dropMenu-view"
                open={Boolean(openSettingRange) || false}
                anchorEl={openSettingRange}
                onClose={onCloseChangeRange}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                onDoubleClick={(e) => e.stopPropagation()}
            >
                <div>
                    <FormControl component="fieldset" id={`form-control-share-status-${view.id}`}>
                        <RadioGroup
                            className={`share-status-li ${
                                currentRange === Constant.VISIBILITY_SETTING_TYPE.PRIVATE
                                    ? 'share-status-li-checked'
                                    : ''
                            }`}
                            aria-label="position"
                            id={`share-status-label-${view.id}-${Constant.VISIBILITY_SETTING_LABEL.PRIVATE}-formGroup`}
                            onChange={() =>
                                setCurrentRange(Constant.VISIBILITY_SETTING_TYPE.PRIVATE)
                            }
                            row
                            style={{
                                opacity: userDetail.id !== view?.creator ? 0.7 : 1
                            }}
                        >
                            <FormControlLabel
                                className='label-range-view-helpdesk'
                                value={Constant.VISIBILITY_SETTING_LABEL.PRIVATE}
                                control={
                                    <Radio
                                        checked={
                                            currentRange ===
                                            Constant.VISIBILITY_SETTING_TYPE.PRIVATE
                                        }
                                        disabled={
                                            currentRange ===
                                                Constant.VISIBILITY_SETTING_TYPE.PRIVATE ||
                                            view?.viewType === Constant.VIEW_TYPE.DEFAULT ||
                                            userDetail.id !== view?.creator
                                        }
                                        color="secondary"
                                    />
                                }
                                label={
                                    <span className="label-range-view">
                                        {Constant.VISIBILITY_SETTING_LABEL.PRIVATE}
                                    </span>
                                }
                                labelPlacement={'end'}
                                id={`share-status-label-${view.id}-${Constant.VISIBILITY_SETTING_LABEL.PRIVATE}`}
                            />
                        </RadioGroup>

                        <RadioGroup
                            className={`share-status-li ${
                                currentRange === Constant.VISIBILITY_SETTING_TYPE.PROJECT
                                    ? 'share-status-li-checked'
                                    : ''
                            }`}
                            aria-label="position"
                            id={`share-status-label-${view.id}-${Constant.VISIBILITY_SETTING_LABEL.PROJECT}-formGroup`}
                            onChange={() =>
                                setCurrentRange(Constant.VISIBILITY_SETTING_TYPE.PROJECT)
                            }
                            row
                        >
                            <FormControlLabel
                                className='label-range-view-helpdesk'
                                value={Constant.VISIBILITY_SETTING_LABEL.PROJECT}
                                control={
                                    <Radio
                                        checked={
                                            currentRange ===
                                            Constant.VISIBILITY_SETTING_TYPE.PROJECT
                                        }
                                        disabled={
                                            currentRange ===
                                                Constant.VISIBILITY_SETTING_TYPE.PROJECT ||
                                            view?.viewType === Constant.VIEW_TYPE.DEFAULT
                                        }
                                        color="secondary"
                                    />
                                }
                                label={
                                    <span className="label-range-view">
                                        {Constant.VISIBILITY_SETTING_LABEL.PROJECT}
                                    </span>
                                }
                                labelPlacement={'end'}
                                id={`share-status-label-${view.id}-${Constant.VISIBILITY_SETTING_LABEL.PROJECT}`}
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
            </Popover>

            {/* Dialog confirm delete view */}
            <ConfirmDialog
                isOpen={isConfirmDeleteView}
                msgConfirm={I18n.get('COMMSG029')}
                closeCallBack={onClickCloseConfirmDeleteView}
                okCallBack={onClickOkConfirmDeleteView}
                textClose={I18n.get('COMBTN007')}
            />

            {/* Dialog confirm hide view */}
            <ConfirmDialog
                isOpen={isConfirmHideView}
                msgConfirm={I18n.get('COMMSG032')}
                closeCallBack={onClickCloseConfirmHideView}
                okCallBack={onClickOkConfirmHideView}
                textClose={I18n.get('COMBTN007')}
            />

            <ConfirmDialog
                isOpen={isConfirmChangeRange}
                msgConfirm={
                    isConfirmChangeRange === Constant.VISIBILITY_SETTING_TYPE.PRIVATE
                        ? I18n.get('MSG-CHANGE-PRIVATE-VIEW')
                        : I18n.get('MSG-CHANGE-PROJECT-VIEW')
                }
                closeCallBack={() => {
                    setIsConfirmChangeRange(null);
                    setCurrentRange(view.visibleType);
                }}
                okCallBack={onClickOkChangeRange}
            />
        </>
    );
};

SettingView.propTypes = {
    setIsOpenDialogViewChanged: PropTypes.any,
    userDetail: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    setViewNameErrorType: PropTypes.any,
    setIsOpenDialogViewNameError: PropTypes.any,
    view: PropTypes.any,
};